export default "__VITE_ASSET__353572c2__"